import React, { useEffect, useRef } from "react";
import Balancer from "react-wrap-balancer";
import classNames from "classnames";

import type { Article, SponsorDetails } from "lib/types/article";
import ProgressBar from "components/progressBar/progressBar";
import Markdown from "components/markdown/markdown";
import { setCssVariable } from "../../lib/utils";

export type SponsorBannerProps = {
  data: SponsorDetails;
  sponsorshipType?: Article["sponsorshipType"];
};

const SponsoredBanner: React.FC<SponsorBannerProps> = ({
  data,
  sponsorshipType,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (ref.current) {
      const height = ref.current.getBoundingClientRect().height;
      setCssVariable("--sponsorBarHeight", `${height}px`);

      ref.current.style.clipPath = `inset(0px 0px 2px 0px)`;
    }
  }, [ref]);

  return (
    <div
      className="h-0"
      id="sponsor-banner__nav"
      data-testid={"sponsoredBanner__nav"}
    >
      <div className="absolute w-100 bg-white" ref={ref}>
        <div
          data-testid={"sponsoredBanner__inner"}
          className={classNames(
            "flex items-center justify-center gap-x-4  border-t-[1px]",
            {
              "border-b-[1px]": !data.withProgressBar,
            }
          )}
        >
          <p className="select-none px-4 py-1 text-center text-[14px] text-black">
            <Balancer>
              <span
                className="font-bold"
                dangerouslySetInnerHTML={{
                  __html: `${sponsorshipType || "Sponsored by"} ${data.name}`,
                }}
              />{" "}
              <span className={"hidden md:inline"}>
                <Markdown
                  text={data.description}
                  options={{ forceBlock: false }}
                />
              </span>
            </Balancer>
          </p>
        </div>
        {data.withProgressBar && <ProgressBar />}
      </div>
    </div>
  );
};

export default SponsoredBanner;
